import PropTypes from "prop-types";
import React, {useState} from 'react';
import { MenuItem, Select, TableCell } from '@mui/material';
import { useGetCustomPlansQuery } from 'services/user-service';
import { useParams } from 'react-router-dom';

const PlanSelector = ({ row }) => {
    const { id: partnerId } = useParams();
    const { data: planNames } = useGetCustomPlansQuery({ PartnerId: partnerId });
    
    const [currentPlan, setCurrentPlan] = useState(row.plan?.customPlanId || '')

    const handleOpenCofirmModal = (event) => {
        setCurrentPlan(event.target.value)
    }

    return (
        <TableCell align="center">
            <Select
                value={currentPlan}
                onChange={handleOpenCofirmModal}
                size="small"
                displayEmpty
                sx={{
                    fontSize: '14px',
                    minWidth: '120px',
                    '& .MuiSelect-select': {
                        padding: '6px 10px'
                    }
                }}
            >
                <MenuItem value="" sx={{ fontSize: '14px' }} disabled>
                    Choose Plan
                </MenuItem>
                {planNames?.customPlan?.map((plan) => (
                    <MenuItem
                        key={plan._id}
                        value={plan._id}
                        sx={{ fontSize: '14px' }}
                    >
                        {plan.planName}
                    </MenuItem>
                ))}
            </Select>
        </TableCell>
    );
};

PlanSelector.propTypes = {
    row: PropTypes.shape({
        id: PropTypes.string.isRequired,
        plan: PropTypes.shape({
            customPlanId: PropTypes.string
        })
    }).isRequired,
    setRefetchUser: PropTypes.func.isRequired
};

export default PlanSelector;